// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { RootReducerState } from 'apps/dashboard/store/reducer';
import { useEffect, useState } from 'react';
import { BsChatSquareText } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { noteServices } from '@deliveries-app/services';
import toast from 'react-hot-toast';
import { darkenColor } from '../../../utils/helpers';

interface NoteProps {
  setShowNote: (val: boolean) => void;
  showNote: boolean;
  date: Date;
}

const Note = ({ setShowNote, showNote, date }: NoteProps) => {
  const branch_id = useSelector(
    (state: RootReducerState) => state.dashboard.selectedBranch.id
  );

  const branch = useSelector(
    (state: RootReducerState) => state.dashboard.selectedBranch
  );

  const [note, setNote] = useState<string>('');

  const handleNote = () => {
    setShowNote(!showNote);
  };

  const postNote = async () => {
    try {
      await noteServices
        .addNoteToDashboard(branch_id, {
          date: moment(date).format('yyyy-MM-DD'),
          description: note,
        })
        .then((res) => toast.success('Note Updated!'));
    } catch (error) {
      toast.error('Error when updated!');
    }
  };

  const getNote = async () => {
    try {
      await noteServices
        .getNoteToDashboard(branch_id, moment(date).format('yyyy-MM-DD'))
        .then((res) => setNote(res.description));
    } catch (error) {
      console.log('Note Not Found! ');
      setNote('');
    }
  };

  useEffect(() => {
    getNote();
  }, [date]);

  return (
    <>
      <div
        className="
                z-20 cursor-pointer
              "
        onClick={handleNote}
      >
        <BsChatSquareText className="h-6 w-6" />
      </div>

      {showNote && (
        <div className="absolute right-0 top-[60px] z-50">
          <div className="w-[400px] rounded border-2 border-gray-200 bg-white p-3">
            <textarea
              value={note}
              rows={4}
              onChange={(val) => setNote(val.target.value)}
              className="
            block
            w-full
            rounded-md
            border
            border-gray-300
            py-3 px-4
            shadow-sm focus:border-blue-500
            focus:ring-blue-500"
            />
            <div className="flex flex-row justify-between">
              <div className="mt-2 flex">
                <button
                  className="
                  mr-2
                  flex
                  cursor-pointer
                  self-center
                  rounded
                  px-4
                  py-2
                  text-sm
                  font-medium"
                  style={{
                    color: 'white',
                    backgroundColor: branch.branch_colour,
                  }}
                  onMouseEnter={(e) =>
                    ((e.target as HTMLDivElement).style.backgroundColor =
                      darkenColor(branch.branch_colour, 20))
                  }
                  onMouseLeave={(e) =>
                    ((e.target as HTMLDivElement).style.backgroundColor =
                      branch.branch_colour)
                  }
                  onClick={postNote}
                >
                  Save
                </button>
                <button
                  className="
                  mr-2
                  flex
                  flex
                  cursor-pointer
                cursor-pointer
                  self-center
                self-center
                rounded
                  rounded
                border
                border-gray-200
                px-4
                py-2
                px-4
                py-2
                text-sm
                text-sm
                font-medium
                font-medium
                text-black
                "
                  style={{
                    backgroundColor: branch.branch_colour,
                  }}
                  onMouseEnter={(e) =>
                    ((e.target as HTMLDivElement).style.backgroundColor =
                      darkenColor(branch.branch_colour, 20))
                  }
                  onMouseLeave={(e) =>
                    ((e.target as HTMLDivElement).style.backgroundColor =
                      branch.branch_colour)
                  }
                  onClick={() => setShowNote(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Note;
